import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import Calendario from './Calendario';
import CalendarioPersonal from './CalendarioPersonal';

const CalendarioAcceso = () => {
  const { user } = useAuth();
  const esKarla = String(user?.email || '').trim().toLowerCase() === 'karla@homes.com';
  return esKarla ? <CalendarioPersonal /> : <Calendario />;
};

export default CalendarioAcceso;
